<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data.title"
      [subheader]="data.p1"
      [separator]="false"
      [buttonText]="data.button_text"
      [buttonUrl]="data.button_link"
    />
    <email-margin [height]="36" />
  </ng-container>

  <ng-container body>
    <email-gdpr-reports [reports]="data.reports" />
  </ng-container>

  <ng-container footer>
    <email-link
      [href]="data.footer_link"
      [label]="data.footer_link_text"
      textPreset="inline"
      [textOpts]="{ size: 'small', color: 'light' }"
    /><br />
    <email-text [contents]="data.footer_p1" color="light" presetName="inline" size="small" />
  </ng-container>
</email-layout>
